module.exports = __webpack_public_path__ + "@/assets/img/dashboard-due-alert3.71d4366f.png";